import React from 'react'
import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import { NightlyPreviousSpecialEditionsV2 } from './PreviousSpecialEditions'

export const NightlyPreviousSpecialEditionsRegistration =
    createRegisterableComponentWithData(
        'nightly-previous-special-editions',
        EditionLoader,

        ({ ...props }, data, services) => {
            if (!data.loaded) return null

            const editions = data.result.documents
            if (!editions) {
                services?.log?.error(
                    data,
                    'NightlyPreviousSpecialEditions: empty result',
                )
                return null
            }

            return (
                <NightlyPreviousSpecialEditionsV2
                    editions={editions}
                    onEvent={services.onEvent}
                    title="Latest Nightly On Editions"
                />
            )
        },
    )
